import { Stepper } from 'modules/shared/components';

export default function WorkProgressStepper({ steps, activeStep, onStepClick }) {
  return <Stepper steps={steps} activeStep={activeStep} onStepClick={onStepClick} />;
}
